var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.291,
    height: 36.291,
    viewBox: "0 0 36.291 36.291",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sad",
    transform: "translate(-4683.204 -2167.377)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_28",
    "data-name": "Ellipse 28",
    cx: 18.145,
    cy: 18.145,
    r: 18.145,
    transform: "translate(4683.204 2167.377)",
    fill: "#f7db83"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_196",
    "data-name": "Group 196"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    d: "M4694.872,2184.343a2.336,2.336,0,1,1-2.292-2.782A2.573,2.573,0,0,1,4694.872,2184.343Z",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M4688.822,2181.855a.722.722,0,0,1-.271-.053.712.712,0,0,1-.388-.93,4.279,4.279,0,0,1,5.583-2.332.712.712,0,0,1-.542,1.318,2.854,2.854,0,0,0-3.724,1.556A.711.711,0,0,1,4688.822,2181.855Z",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M4707.827,2184.343a2.336,2.336,0,1,0,2.293-2.782A2.573,2.573,0,0,0,4707.827,2184.343Z",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    d: "M4713.878,2181.855a.711.711,0,0,1-.658-.441,2.854,2.854,0,0,0-3.725-1.556.712.712,0,0,1-.542-1.318,4.278,4.278,0,0,1,5.584,2.332.712.712,0,0,1-.388.93A.724.724,0,0,1,4713.878,2181.855Z",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    d: "M4706.665,2195.36a.714.714,0,0,1-.576-.291,6.46,6.46,0,0,0-10.454,0,.713.713,0,0,1-1.15-.842,7.887,7.887,0,0,1,12.754,0,.712.712,0,0,1-.154.995A.7.7,0,0,1,4706.665,2195.36Z",
    fill: "#3c3c3b"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    d: "M4713.113,2203.165h0a3.425,3.425,0,0,1-3.181-4.7l3.181-7.957,3.181,7.957A3.426,3.426,0,0,1,4713.113,2203.165Z",
    fill: "#5f90f4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSad);
export default __webpack_public_path__ + "static/media/sad.d9ddcd68279076156f8cfa6b92e51b4f.svg";
export { ForwardRef as ReactComponent };